import { render, staticRenderFns } from "./Forbidden.vue?vue&type=template&id=f72c66a4"
import script from "./Forbidden.vue?vue&type=script&lang=js"
export * from "./Forbidden.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f72c66a4')) {
      api.createRecord('f72c66a4', component.options)
    } else {
      api.reload('f72c66a4', component.options)
    }
    module.hot.accept("./Forbidden.vue?vue&type=template&id=f72c66a4", function () {
      api.rerender('f72c66a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/Forbidden.vue"
export default component.exports